import Form, { style } from "element/form";
import args from "standard/args";
import connected from "standard/connected";
import define from "standard/define";
import filter from "standard/filter";
import on from "standard/on";
import paint from "standard/paint";
import trait from "standard/trait";

@define("m-check-your-email")
class CheckYourEmail extends Form {
  @connected
  @paint
  [trait.template]() {
    return `
      <form class='${style.form}' novalidate>
        <button class='${style.form__button}'>Abrir aplicativo de e-mail</button>
      </form>
    `;
  }

  @on.submit("form")
  @filter.prevent
  [trait.onSubmit]() {
    const [, url] = args.email.split("@");
    window.open(`//${url}`, "_blank");
    return this;
  }
}

export default CheckYourEmail;
